<script>

import VoucherTypes from '@/views/AadenPages/VipPage/VoucherTypes.vue'
import AllVoucher from '@/views/AadenPages/VipPage/UserCenter/AllVoucher.vue'

export default {
  name: 'VoucherIndex',
  components: {
    AllVoucher,
    VoucherTypes
  },
  data () {
    return {
      tab: null
    }
  }
}
</script>

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>VoucherTypes</v-tab>
      <v-tab>AllVoucher</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <voucher-types />
      </v-tab-item>
      <v-tab-item>
        <all-voucher />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style scoped>

</style>
